import { createFileRoute } from '@tanstack/react-router'
import { EditCampaignPage } from '../../../../components/campaigns/CampaignWizard'

/** The wizard on a draft campaign: its questionnaire, perimeter and agents. */
export const Route = createFileRoute('/$org/campaigns/$campaignUid/edit')({
  component: EditCampaignPage,
})
